import { render, staticRenderFns } from "./DetailPriceOffering.vue?vue&type=template&id=3bf321da&scoped=true"
import script from "./DetailPriceOffering.vue?vue&type=script&lang=js"
export * from "./DetailPriceOffering.vue?vue&type=script&lang=js"
import style0 from "./DetailPriceOffering.vue?vue&type=style&index=0&id=3bf321da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf321da",
  null
  
)

export default component.exports